import guid from '@/lib/guid'
import Vue from 'vue';
export default {
  mInit(state, projects) {
    // Vue.set(state, 'projects', projects);
  }
};
